<template>
  <div
    :class="['scroll-back', visible ? 'show' : 'hide']"
    @click="handleBackTop"
  ></div>
</template>

<script>
import { SCROLL_BACK_HEIGHT } from '@/utils/config'
export default {
  name: 'ScrollBack',
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.changeBackTopVisible)
  },
  destroyed () {
    window.removeEventListener('scroll', this.changeBackTopVisible)
  },
  methods: {
    handleBackTop () {
      window.scrollTo(0, 0)
    },
    changeBackTopVisible () {
      this.visible = document.documentElement.scrollTop > SCROLL_BACK_HEIGHT
    }
  }
}
</script>

<style lang="less" scoped>
.scroll-back {
  position: fixed;
  bottom: 180px;
  right: 50px;
  z-index: 1040;
  width: 55px;
  height: 55px;
  border: 1px solid #dcdcdc;
  border-radius: 50%;
  text-align: center;
  background-color: #fff;
  transition: 0.1s ease-in;
  cursor: pointer;
  &.show {
    display: block;
  }
  &.hide {
    display: none;
  }
  &:hover {
    background-color: hsl(0, 0, 95%);
    &.scroll-back::after {
      border-bottom-color: hsl(0, 0, 95%);
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: calc(50% - 5px);
    left: 50%;
    border: 5px solid transparent;
    border-radius: 2px;
    border-bottom-color: #333;
    transform: translate(-50%, -50%) scale(1.9);
  }
  &::after {
    content: "";
    position: absolute;
    top: calc(50% - 3px);
    left: 50%;
    border: 5px solid transparent;
    border-radius: 2px;
    border-bottom-color: #fff;
    transform: translate(-50%, -50%) scale(1.9);
  }
}
</style>
